import { apiGet } from "../ApiMethod";
import { setDrone } from "../../mappers";
import { CheckValue } from "../../service";

export const getDronesList = async (params = {}, cancelToken = null) => {
  const response = await apiGet("_drones", params, null, cancelToken);
  const drones = CheckValue(response.data?.drones) ? response.data.drones : [];
  return {
    ...response,
    rowData: drones.map(setDrone),
  };
};
